module.exports = __webpack_public_path__ + "static/media/cm.0b2591b6.svg";